var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlug = function SvgIconPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.957 2.957a1 1 0 0 0-1.414-1.414L13.5 4.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l.418.418-4.673 4.673h-.001a3.99 3.99 0 0 0 0 5.653v.001l1.299 1.298-4.543 4.543a1 1 0 1 0 1.414 1.414l4.543-4.543 1.297 1.298h.001a3.99 3.99 0 0 0 5.653 0l4.674-4.673.418.418a1 1 0 0 0 1.414-1.414L19.414 10.5l3.043-3.043a1 1 0 0 0-1.414-1.414L18 9.086 14.914 6zM11.625 5.54 6.95 10.213l-.001.002a1.99 1.99 0 0 0 0 2.82l.001.002 1.989 1.988.036.037 1.99 1.989a1.99 1.99 0 0 0 2.82 0l.001-.002 4.675-4.674z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPlug;